<template>
  <div class="ln-phone-register">
    <Form ref="form">
      <Field v-model="uname" name="uname" placeholder="请输入账号" :rules="[{ required: true, message: '请填写账号' }]">
        <i slot="left-icon" class="iconfont iconuser"></i>
      </Field>
      <!-- <check-code v-model="code" :params="codeParams"></check-code> -->
      <Password v-model="upass" placeholder="请输入密码"></Password>
      <Password v-model="confirmPassword" :confirm-pass="upass" placeholder="请确认密码"></Password>
      <div class="bottom">
        <Row class="login-row" gutter="10">
          <Col span="12"><Button block type="info" @click="changeComponent('Login')">返回</Button></Col>
          <Col span="12"><Button block type="info" @click="next">注册并登录</Button></Col>
        </Row>

        <Row class="login-row link-wrap" style="justify-content: center">
          <AgreeRegister v-model="agree"></AgreeRegister>
          <span style="font-size: 13px; margin-top: 7px; margin-left: 5px">同意游戏</span
          ><span class="link" style="vertical-align: center; margin-left: 0px; margin-top: 7px" @click="openProtocal(1)"
            >《用户协议》</span
          >
          <span style="font-size: 13px; margin-top: 7px">及</span>
          <span style="font-size: 13px; margin-top: 7px" @click="openProtocal(2)" class="link">《隐私协议》</span>
        </Row>
      </div>
    </Form>

    <!-- 用户协议弹窗 -->
    <div v-if="isProto" class="lngame_proto">
      <div class="lngame_proto_con" style="height: 100%; width: 100%">
        <div style="height: 90%; padding: 15px">
          <iframe :src="userProtocol" style="width: 100%; height: 100%" frameborder="0"></iframe>
        </div>
      </div>
      <van-icon
        style="position: absolute; right: 0; top: 0; right: 10px; top: 10px; z-index: 3000"
        name="cross"
        @click="closeProto"
      />
    </div>
  </div>
</template>

<script>
import { Form, Field, Button, Col, Row, Dialog } from 'vant';
import { commonMixin } from '@/mixin';
import AgreeRegister from '@/components/AgreeRegister';
import Password from '@/components/Password';
import server from '@/server';
import channelServer from '@/server/channelServer';
// import CheckCode from '@/components/CheckCode';
import { getUrlParams } from '@/utils';
import AES from '@/AES';
export default {
  name: 'ln-phone-register',
  mixins: [commonMixin],
  components: { Form, Field, Button, Col, Row, Password, AgreeRegister },
  data() {
    return {
      uname: '',
      code: '',
      upass: '',
      agree: false,
      isProto: false,
      confirmPassword: '',
      accountRegiTimer: null,
    };
  },
  created() {},
  computed: {
    codeParams() {
      return {
        mobile: this.uname,
        type: 2 /* 注册 */,
      };
    },
  },
  methods: {
    next() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      }
      if (this.accountRegiTimer) clearTimeout(this.accountRegiTimer);
      this.accountRegiTimer = setTimeout(() => {
        this.formCheck('form').then(() => {
          let IV = AES.generatekey();
          const params = {
            uname: this.uname,
            upass: IV + AES.encrypt(encodeURI(this.upass), 'LN_85%@A6f*&0d!k', IV),
            decrypt_pwd: 1,
          };
          this.$store.commit('SET_USER_INFO', { name: this.uname, pwd: this.upass });
          channelServer.accountRegister(params).then(({ ret, msg }) => {
            if (ret == 0) {
              const params = {
                uname: this.uname,
                upass: this.upass,
              };
              localStorage.setItem('lnUserAccount', this.uname);
              localStorage.setItem('lnUserPass', this.upass);
              server.login(params);
            }
          });
        });
      }, this.$store.state.button_interval);
    },
    // 打开用户协议
    openProtocal(type) {
      this.isProto = true;
      this.userProtocol =
        type == 1
          ? `https://apisdk.lnqwe.com/uc/user/user_protocol?appid=${getUrlParams('appid')}`
          : `https://apisdk.lnqwe.com/uc/user/privacy_protocol?appid=${getUrlParams('appid')}`;
    },
    closeProto() {
      this.isProto = false;
    },
  },
};
</script>
<style lang="scss">
/* @import url() */
.ln-phone-register {
}
.lngame_proto {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 2002;
  background: rgba(0, 0, 0, 0.4);
}
.lngame_proto_con {
  width: 100%;
  height: 350px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
